import { createGlobalState } from '@vueuse/core';
import { ref, watch, computed } from 'vue';
import { useAuthStore } from './auth';
import { isNonNullable } from '@/utils/nullability-helpers';
import { getUserEvents } from '@/services/events.service';
import type { EventRow } from '@shared-types/events.types';

export const useEventsStore = createGlobalState(() => {
    const { organizationId } = useAuthStore();

    // the type has undefined to indicate that the events are not loaded yet
    const events = ref<EventRow[] | undefined>(undefined);
    const completedEvents = computed<EventRow[] | undefined>(() =>
        events.value?.filter((event) => event.status === 'completed'),
    );
    const cancelledEvents = computed<EventRow[] | undefined>(() =>
        events.value?.filter((event) => event.status === 'cancelled'),
    );

    watch(organizationId, async (newVal, oldVal) => {
        if (newVal === oldVal) {
            return;
        }

        if (isNonNullable(organizationId.value)) {
            events.value = await getUserEvents(organizationId.value);
        }
    });

    const addEvent = (event: EventRow) => {
        if (isNonNullable(events.value)) {
            events.value.push(event);
        }
    };

    return {
        events,
        completedEvents,
        cancelledEvents,
        addEvent,
    };
});
